import * as React from "react"
import LazyImage from "../general/lazyImage"
import Translate from '../general/translate'

const Podcastvideosection = () => {

  return (    
    <div className="pt-24 pb-14 bg-[#643ADA]" id="podcast">
        <div className="w-5/6 m-auto">
            <h3 className="text-center text-md leading-tight font-extrabold text-white opacity-60 tracking-wide mb-8">
                <Translate id="podcast.section.title" foldername="home" filename="home-podcastvideosection" />
            </h3>
            <h2 className="text-center leading-tight text-3xl lg:text-5xl text-[#F3F3F1] font-bold mb-10">
                <Translate id="podcast.section.subtitle" foldername="home" filename="home-podcastvideosection" />
                <span className="text-[#FFCA1D] font-extrabold">
                    <Translate id="podcast.section.highlight" foldername="home" filename="home-podcastvideosection" />
                </span>
            </h2>
            <LazyImage src="/logos/logo-lessons-from-a-podcaster.webp" className="h-36 w-auto cursor-pointer my-14 m-auto" alt="Lessons from a podcaster Logo"/>
            <p className="text-xl lg:w-5/6 m-auto text-center text-white opacity-70 mb-14">
                <Translate id="podcast.section.description" foldername="home" filename="home-podcastvideosection" />
            </p>
        </div>      
    
        <div className="flex justify-center px-10 lg:w-1/2 m-auto mt-10 gap-2">
            <div className="w-1/3 p-0">
                <a href="https://open.spotify.com/show/75hfiON226nVpCXrd9Gsaa" target="_blank" rel="noopener noreferrer">
                    <button className="">
                        <LazyImage src="/lessons-from-a-podcaster/listen-on-spotify.webp" alt={<Translate id="podcast.link.spotify" foldername="home" filename="home-podcastvideosection" />} className="w-full" />
                    </button>
                </a>
            </div>
            <div className="w-1/3 p-0">
                <a href="https://podcasts.apple.com/gb/podcast/lessons-from-a-podcaster/id1724239437" target="_blank" rel="noopener noreferrer">
                    <button className="">
                        <LazyImage src="/lessons-from-a-podcaster/listen-on-apple-podcasts.webp" alt={<Translate id="podcast.link.apple" foldername="home" filename="home-podcastvideosection" />} className="w-full" />
                    </button>
                </a>
            </div>
            <div className="w-1/3 p-0">
                <a href="https://www.youtube.com/@Podsqueeze/sub_confirmation=1" target="_blank" rel="noopener noreferrer">
                    <button className="">
                        <LazyImage src="/lessons-from-a-podcaster/listen-on-youtube.webp" alt={<Translate id="podcast.link.youtube" foldername="home" filename="home-podcastvideosection" />} className="w-full" />
                    </button>
                </a>
            </div>
        </div>
    </div>
  )
}

export default Podcastvideosection